export const formatMessageToTranslationKey = (message: string): string => {
  let formattedKey = message.trim()

  // Remove special characters (keep alphanumeric characters and spaces)
  formattedKey = formattedKey.replace(/[^a-zA-Z0-9\s_-]/g, '')

  // Replace one or more spaces with a single underscore
  formattedKey = formattedKey.replace(/\s+/g, '_')

  return formattedKey
}
